import { sha256Hex } from '~~/shared/utils/hashedEmail'

/**
 * Standalone PebblePost / hashed-email (HEM) helper.
 * Kept separate from Hightouch and the GTM store (separation of concerns).
 */
export async function pushHemValueToDataLayer(email: string | null | undefined): Promise<string | undefined> {
  const hemValue = await sha256Hex(email)
  if (!hemValue || typeof window === 'undefined') {
    return undefined
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ hem_value: hemValue })
  return hemValue
}

export function hasLoginEventCookie(): boolean {
  if (typeof document === 'undefined') {
    return false
  }

  return document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .some((cookie) => cookie === 'loginEvent=true')
}
